<template>
  <v-dialog v-model="showDialog" persistent max-width="1200px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <h5>
            FOLIO RENTA: {{ renta.folioRenta }} / SALDO PENDIENTE:
            <b class="red--text">$ {{ formatMoney(saldoPendiente) }}</b>
          </h5>
          <v-form ref="formRentaPago" :v-model="true" lazy-validation>
            <v-layout wrap class="container">
              <v-flex xs12 sm12 md2>
                <v-text-field
                  label="Número pago"
                  v-model="rentaPago.numPago"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-menu
                  ref="menuFechaPago"
                  :close-on-content-click="false"
                  v-model="openFechaPago"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  box
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    v-model="rentaPago.fechaPago"
                    label="Fecha pago"
                    prepend-icon="event"
                    readonly
                    :rules="[
                      () => !!rentaPago.fechaPago || 'El campo es requerido',
                    ]"
                    required
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="rentaPago.fechaPago"
                    min="2018-01-01"
                    @change="$refs.menuFechaPago.save(rentaPago.fechaPago)"
                    locale="es"
                    :disabled="!nuevoPago"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm12 md4>
                <v-menu
                  ref="menuHoraPago"
                  v-model="openHoraPago"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :disabled="true"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="rentaPago.horaPago"
                    label="Hora del pago"
                    prepend-icon="access_time"
                    readonly
                  ></v-text-field>
                  <v-time-picker
                    v-model="rentaPago.horaPago"
                    full-width
                    @click:minutes="$refs.menuHoraPago.save(rentaPago.horaPago)"
                    :disabled="!nuevoPago"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="openHoraPago = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.menuHoraPago.save(horaPago)"
                      >OK</v-btn
                    >
                  </v-time-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm12 md3>
                <v-text-field
                  label="Monto del pago"
                  v-model="rentaPago.montoPago"
                  :rules="[
                    (v) => !!rentaPago.montoPago || 'El campo es requerido',
                  ]"
                  prefix="$"
                  type="number"
                  @input="calcularCambio"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md3>
                <v-text-field
                  label="Cambio a devolver"
                  v-model="rentaPago.cambioDevuelto"
                  prefix="$"
                  type="number"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md6>
                <v-select
                  v-model="rentaPago.formaPagoId"
                  :items="formasPago"
                  :loading="loadingFormasPago"
                  item-text="descripcion"
                  item-value="formaPagoId"
                  label="Forma del pago"
                  placeholder="Forma del pago"
                  single-line
                  :rules="[
                    () => !!rentaPago.formaPagoId || 'El campo es requerido',
                  ]"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-select
                  v-model="rentaPago.conceptoPagoId"
                  :items="conceptosPago"
                  :loading="loadingConceptosPago"
                  item-text="descripcion"
                  item-value="conceptoPagoId"
                  label="Concepto del pago"
                  single-line
                  :rules="[
                    () => !!rentaPago.conceptoPagoId || 'El campo es requerido',
                  ]"
                  required
                ></v-select>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Referencia del pago"
                  v-model="rentaPago.referenciasPago"
                  hint="Referencia del pago"
                  :rules="[
                    () =>
                      !!rentaPago.referenciasPago || 'El campo es requerido',
                  ]"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Observaciones (opcional)"
                  v-model="rentaPago.observaciones"
                  hint="Observaciones (opcional)"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12 class="text-md-right">
                <v-btn
                  color="primary darken-4"
                  :loading="$store.state.operationInProgress"
                  :disabled="savePagoDisabled"
                  @click="savePago"
                  >Guardar pago</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false"
          >Cerrar ventana</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Pago guardado con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <loading-alert></loading-alert>
    <snack-bar></snack-bar>
  </v-dialog>
</template>

<script>
import moment from "moment";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

//Services
import conceptoPagoService from "@/services/conceptoPagoService";
import formaPagoSevice from "@/services/formaPagoService";
import rentaPagoService from "@/services/rentaPagoService";

export default {
  components: {
    loadingAlert,
    snackBar,
  },
  props: {
    renta: {
      type: Object,
    },
    rentaPago: {
      type: Object,
    },
    nuevoPago: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      openFechaPago: false,
      openHoraPago: false,
      loadingFormasPago: false,
      loadingConceptosPago: false,
      savePagoDisabled: false,
      formasPago: [],
      conceptosPago: [],
    };
  },
  mounted() {
    // this.fechaPago = moment(new Date(this.rentaPago.fechaPago)).format(
    //   "YYYY-MM-DD"
    // );
    // this.horaPago = moment(new Date(this.rentaPago.horaPago)).format("hh:mm");
    this.getConceptosPago();
    this.getFormasPago();
  },
  computed: {
    saldoPendiente: function () {
      return this.renta.totalFinal - this.renta.pagado;
    },
  },
  // watch: {
  //   rentaPago: function(newPago) {
  //     this.fechaPago = moment(new Date(this.rentaPago.fechaPago)).format(
  //       "YYYY-MM-DD"
  //     );
  //     this.horaPago = moment(new Date(this.rentaPago.fechaPago)).format(
  //       "hh:mm"
  //     );
  //   }
  // },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getConceptosPago() {
      let self = this;
      self.loadingConceptosPago = true;

      conceptoPagoService
        .getAll()
        .then((result) => {
          self.conceptosPago = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingConceptosPago = false;
        });
    },
    getFormasPago() {
      let self = this;
      self.loadingFormasPago = true;

      formaPagoSevice
        .getAll()
        .then((result) => {
          self.formasPago = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingFormasPago = false;
        });
    },
    async savePago() {
      let self = this;
      if (self.$refs.formRentaPago.validate()) {
        self.operationStart();
        self.savePagoDisabled = true;
        if (self.nuevoPago) {
          await self.addPago();
        } else {
          await self.updatePago();
        }

        setTimeout(() => {
          self.showDialog = false;
          self.resetForm();
        }, 2000);
      }
    },
    async addPago() {
      let self = this;

      await rentaPagoService
        .add(self.rentaPago)
        .then((result) => {
          self.operationSuccess();

          self.$store.state.snackbar.color = "success";
          self.$store.state.snackbar.text =
            "Pago agregado con éxito, guarda la renta para aplicar los cambios";
          self.$store.state.snackbar.visible = true;
          self.$emit("onPagoAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
            self.verificarCorteCaja();
          }, 1500);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    async updatePago() {
      let self = this;

      await rentaPagoService
        .update(self.rentaPago)
        .then((result) => {
          self.operationSuccess();

          self.$store.state.snackbar.color = "success";
          self.$store.state.snackbar.text = "Pago guardado con éxito";
          self.$store.state.snackbar.visible = true;
          self.$emit("onPagoUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
            self.verificarCorteCaja();
          }, 1500);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    calcularCambio() {
      let self = this;
      let cambioDevuelto = this.rentaPago.montoPago - this.saldoPendiente;
      if (cambioDevuelto < 0) {
        cambioDevuelto = 0;
        self.rentaPago.conceptoPagoId = 2;
      } else {
        self.rentaPago.conceptoPagoId = 3;
      }
      this.rentaPago.cambioDevuelto = cambioDevuelto;
    },
    resetForm() {
      let self = this;
      self.savePagoDisabled = false;
      (self.rentaPago.rentaId = self.renta.rentaId),
        (self.rentaPago.numPago = 0),
        (self.rentaPago.fechaPago = moment(new Date()).format("YYYY-MM-DD")),
        (self.rentaPago.horaPago = moment(new Date()).format("hh:mm")),
        (self.rentaPago.montoPago = 0.0),
        (self.rentaPago.conceptoPagoId = null),
        (self.rentaPago.formaPagoId = null),
        (self.rentaPago.referenciasPago = ""),
        (self.rentaPago.observaciones = "");

      self.operationReset();
      self.$refs.formRentaPago.resetValidation();
    },
  },
};
</script>
